import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { studiedConcepts, hardQuestions } from "../data/content";
export function ProblemSection() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="problem-title" data-id="element-227" data-mp="30hhc1e2eo40s">
      <div className="mx-auto max-w-3xl" data-id="element-228" data-mp="2vpzbus87i7gv">
        <h2 id="problem-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-229" data-mp="2vownos29qj4n">
          When the case gets complicated… <em className="text-wine-700" data-id="element-230" data-mp="35gtyhxpd792u">do you know what to analyze first?</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-231" data-mp="3jftnx7kpbs02">
          There is a difference between knowing orthodontic biomechanics and knowing how to structure your thinking when you face a complex case.
        </p>

        <div className="mt-10 rounded-3xl bg-cream p-6 sm:p-8" data-id="element-232" data-mp="1p4568xn35bbz">
          <p className="font-semibold text-ink" data-id="element-233" data-mp="1k49cdr83r0a5">You may have studied:</p>
          <ul className="mt-4 flex flex-wrap gap-2" data-id="element-234" data-mp="jdn4q2hrew4e">
            {studiedConcepts.map(c => <li key={c} className="rounded-full border border-wine-200 bg-white px-3.5 py-1.5 text-sm font-semibold text-wine-800" data-id="element-235" data-mp="obonemb9wtfc">
                {c}
              </li>)}
          </ul>
        </div>

        <p className="mt-10 text-center font-serif text-2xl font-bold italic text-wine-800" data-id="element-236" data-mp="x4s1mwtqtab1">But when a complex case appears…</p>

        <ul className="mt-6 divide-y divide-wine-100 border-y border-wine-100" data-id="element-237" data-mp="1233bh7k1fkt9">
          {hardQuestions.map(q => <li key={q} className="flex gap-3 py-4 text-[17px] font-medium leading-snug text-ink" data-id="element-238" data-mp="174iu6syqtf8h">
              <HelpCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-wine-600" aria-hidden="true" data-id="element-239" data-mp="1bzy63fd6x129" />
              {q}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-240" data-mp="3dugxdbwejwqc">
          That's where <span className="text-wine-700" data-id="element-241" data-mp="3hv9869kxa9oq">real biomechanical training</span> begins.
        </p>

        <div className="mt-10" data-id="element-242" data-mp="p1226cf215pa">
          <CtaButton label="I want to know where to start" data-id="element-243" data-mp="p23ml7hyn4jo" />
        </div>
      </div>
    </section>;
}